/**
 * Earliest possible anonymous auth bootstrap — imported from index.js before App
 * so signInAnonymously runs while the main bundle is still parsing.
 */
import { signInAnonymously } from 'firebase/auth';
import { auth } from './firebaseConfig';

const LS_UID_KEY = 'fc:anonUid';

const isAuthRoute = () =>
  typeof window !== 'undefined' && window.location.pathname.startsWith('/auth');

const isLocalGuestDevBypass = () =>
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_GUEST_DEV_BYPASS !== 'false' &&
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

const safeLocalStorage = {
  set(key, value) {
    try {
      if (typeof window === 'undefined') return;
      if (value == null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, String(value));
    } catch {
      /* ignore */
    }
  },
};

let bootstrapPromise = null;

export function getGuestBootstrapPromise() {
  return bootstrapPromise;
}

export function prefetchGuestAuth() {
  if (typeof window === 'undefined' || isAuthRoute() || isLocalGuestDevBypass()) {
    return null;
  }
  if (bootstrapPromise) {
    return bootstrapPromise;
  }

  bootstrapPromise = (async () => {
    await auth.authStateReady();
    if (auth.currentUser) {
      return auth.currentUser;
    }
    const cred = await signInAnonymously(auth);
    safeLocalStorage.set(LS_UID_KEY, cred.user.uid);
    return cred.user;
  })().catch((err) => {
    bootstrapPromise = null;
    throw err;
  });

  return bootstrapPromise;
}

if (typeof window !== 'undefined') {
  prefetchGuestAuth();
}
